module.exports = __webpack_public_path__ + "img/door-closed-icon-shadow.416d7fd7.svg";